import { API_BASE_URL } from 'constants/index';
import { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { IProductItem } from '../Helper/interface';

export default function useFetchMarketUpdate() {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [data, setData] = useState<IProductItem[]>([]);

  const fetchMarketUpdate = async (sort_by: string) => {
    try {
      setIsFetching(true);
      const url = sort_by == '' ? `${API_BASE_URL}/products/top-selling?availables=true&category=all_category&per_page=26&homepage_all_category=true&range_type=month&range_value=12` : `${API_BASE_URL}/products/market-update?category=all_category&per_page=26&sort_by=${sort_by}`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        setIsError(true);
        setIsFetching(false);
        return;
      }

      setData(data?.data?.data ?? []);
      setIsFetching(false);
      return data;
    } catch (error) {
      setIsFetching(false);
      setIsError(true);
      setError(error);
      console.log('error fetchMarketUpdate()', error);
    }
  };

  return { data, fetchMarketUpdate, isFetching, isError, error };
}
